import React from 'react';
import cn from 'classnames';
import { Link } from 'gatsby';

import * as styles from './ContentBlock.module.styl';
import { ensureTrailingSlashLocal } from '../utils/ensureTrailingSlash';
import FadeIn from './animations/FadeIn';
import getHelpFileURL from '../utils/getHelpFileURL';

export default function ContentBlock({
  title,
  description,
  linkURL,
  linkLabel,
  children,
  headingEl,
  align = 'left',
  image = null,
}) {
  const Heading =
    headingEl ||
    ((props) => (
      <h2 {...props} className="text-3xl mb-3">
        {title}
      </h2>
    ));

  // child content
  const contentWrapper = (
    <div className={cn(styles.contentWrapper)}>{children}</div>
  );

  // image content
  const imageWrapper = image ? (
    <div className={cn(styles.contentWrapper)}>
      <img src={getHelpFileURL(image)} alt={title || ''} />
    </div>
  ) : null;

  return (
    <div className="max-width mx-auto">
      <div className="lg:grid lg:grid-cols-2 lg:p-16  lg:gap-16 justify-center items-center">
        <div className={align === 'right' ? 'order-1' : ''}>
          <FadeIn>
            {imageWrapper}
            {contentWrapper}
          </FadeIn>
        </div>
        <div>
          <div className="w-[550px] max-w-full py-3 lg:py-12 ">
            <Heading />
            {description ? (
              <p className="text-sm mb-[50px]">{description}</p>
            ) : null}
            {linkURL && linkLabel ? (
              <Link
                className={styles.link}
                to={ensureTrailingSlashLocal(linkURL)}
              >
                {linkLabel}
              </Link>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
